import { render } from "./shareLink.vue?vue&type=template&id=c09590f8&scoped=true"
import script from "./shareLink.vue?vue&type=script&lang=js"
export * from "./shareLink.vue?vue&type=script&lang=js"

import "./shareLink.vue?vue&type=style&index=0&id=c09590f8&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c09590f8"]])

export default __exports__